import { Box, Chip, CircularProgress } from '@mui/material';

interface UpdatingDataChipProps {
  show: boolean;
}

/**
 * Displays a small chip indicator when data is being updated in the background
 * Used to show progressive loading status without blocking the UI
 */
export function UpdatingDataChip({ show }: UpdatingDataChipProps) {
  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 72, sm: 80 },
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1200
      }}
    >
      <Chip
        icon={
          <CircularProgress
            size={14}
            thickness={5}
            sx={{
              color: '#ffffff',
              ml: 0.5
            }}
          />
        }
        label="Updating forecast data"
        size="small"
        sx={{
          backgroundColor: '#ff9800',
          color: '#ffffff',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
          '& .MuiChip-icon': {
            marginLeft: '8px',
            marginRight: '-4px'
          }
        }}
      />
    </Box>
  );
}
